module.exports = __webpack_public_path__ + "static/media/spanish-past-tense-table-1.d7f20599.JPG";